<app-sidebar [isOpen]="isOpen" (close)="onClose()">

  <div class="customizer-container">

    <div class="header">
      <div class="title">
        <span>Personalizar <img src="assets/svg/icon-pencil.svg" alt=""></span>
      </div>
      <button class="close" (click)="onClose()">✕</button>
    </div>

    <div class="content">

      <div class="section">
        <h4 class="fw-bold">Personaliza tu camiseta como más te guste</h4>
        <p class="info-cost">
          <img src="assets/svg/icon-infor.svg" alt="info" />
          Cada item de personalización tiene un costo adicional de S/ 10.00.
        </p>
      </div>

      <ng-container *ngFor="let opt of options">
        <!-- Input type text -->
        <div class="field" *ngIf="opt.inputType === 'text'">
          <label>{{ opt.value }}</label>
          <input class="input" type="text" [placeholder]="'Ingrese ' + opt.value" [(ngModel)]="opt.selectedValue" />
        </div>

        <!-- Input type select (Sí / No) -->
        <div class="field" *ngIf="opt.inputType === 'select'">
          <label>{{ opt.value }}</label>
          <div class="toggle-group">
            <button [class.active]="opt.selectedValue === 'Si'" (click)="opt.selectedValue = 'Si'">Sí</button>
            <button [class.active]="opt.selectedValue === 'No'" (click)="opt.selectedValue = 'No'">No</button>
          </div>
        </div>
      </ng-container>

      <p *ngIf="options.length === 0" style="color: #8a8a8a; font-size: 13px;">Cargando opciones...</p>

      <div class="preview" *ngIf="image">
        <img class="product-img" [src]="image" />
      </div>

    </div>

    <div class="footer">
      <button class="save" (click)="save()">
        Guardar
      </button>
    </div>

  </div>

</app-sidebar>
